/*
  implemented: snippets/product-page-get-main.liquid.
  1. first render show both container (default, variant)
    1.1 show the right one - first render outside mutation observer (if condition).
    1.2 If there is bullets, default container innerHTML = ""
  2. variant onchnage (mutation observer), both containers innerHTML = ""
  3. Only update container (variant) with data based on JSON script

*/
const scriptDefaultData = document.querySelector("script#meta_data_features_default").innerHTML
const {data: defaultData } = JSON.parse(scriptDefaultData);
console.log(defaultData);

const scriptVariantsData = document.querySelector("script#meta_data_features_variants").innerHTML
const variantsData = JSON.parse(scriptVariantsData);
console.log(variantsData);

const scriptNotesData = document.querySelector("script#meta_data_notes_default").innerHTML 
const {data: notesData } = JSON.parse(scriptNotesData);
console.log(notesData);

document.addEventListener("DOMContentLoaded", function () {
  //alert('dfo')

   // Select the node that will be observed for mutations
  const sku_node = document.querySelector("[data-js-product-sku]");

  if(!sku_node){
    return console.log("Cant find sku_node element features")
  }
  
  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: true, subtree: true };
  
  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
         const sku_id = document.querySelector("[data-js-product-sku] span");
          if(!sku_id){
            return console.log("Cant find sku_id element features")
          }
          console.log("A child node has been added or removed, features", sku_id.innerHTML)
         
          const variants_metafield = variantsData[sku_id.innerHTML]
          console.log("variants_metafield", variants_metafield)


          // bullets
          const features_main_desktop = document.querySelector('.desktop [data-js-features-main]')
          const features_variant_desktop = document.querySelector('.desktop [data-js-features-variant]')
          const features_change_desktop = document.querySelector('.desktop [data-js-features-change]')

          const features_main_mobile = document.querySelector('.mobile [data-js-features-main]')
          const features_variant_mobile = document.querySelector('.mobile [data-js-features-variant]')
          const features_change_mobile = document.querySelector('.mobile [data-js-features-change]')

          // drawer 
          const defaultSpecsContainer = document.querySelector("[data-js-specs-default]")
          const variantSpecsContainer = document.querySelector("[data-js-specs-variant]")
          const drawerDefaultBullets = document.querySelector("[data-js-drawer-default-bullets]")
          const drawerVariantBullets = document.querySelector("[data-js-drawer-variant-bullets]")
          const drawerNotesDefault = document.querySelector("[data-js-drawer-notes-default]")
          const drawerNotesVariant = document.querySelector("[data-js-drawer-notes-variant]")
        
          const defaultLength = document.querySelector('[data-js-drawer-length-default]').innerHTML
          const defaultMaxWeight = document.querySelector('[data-js-drawer-max-weight-default]').innerHTML
          const defaultMaxUserHeight = document.querySelector('[data-js-drawer-max-user-height-default]').innerHTML
          const defaultMaxSize= document.querySelector('[data-js-drawer-max-size]').innerHTML


          if(variants_metafield.bullets !== "null" ){
            features_main_desktop.innerHTML = '';
            features_variant_desktop ? features_variant_desktop.innerHTML = '' : null;
            features_change_desktop.innerHTML = variants_metafield.bullets;
            
            features_main_mobile.innerHTML = '';
            features_variant_mobile ? features_variant_mobile.innerHTML = '' : null;
            features_change_mobile.innerHTML = variants_metafield.bullets;

            //drawer 
            defaultSpecsContainer.innerHTML = '';
            const markup = updateSpecs(variants_metafield)
            variantSpecsContainer.innerHTML = markup

            drawerDefaultBullets.innerHTML = "";
            drawerVariantBullets.innerHTML = variants_metafield.bullets;
            
            // Drawer - notes
            drawerNotesDefault.innerHTML = "";
            drawerNotesVariant.innerHTML = updateNote({'max_weight': variants_metafield.max_weight, 'max_height': variants_metafield.max_user_height })
            
            return console.log("Switched to bullets")
            
          }else{
            features_main_desktop.innerHTML = '';
            features_variant_desktop ? features_variant_desktop.innerHTML = '' : null;
            features_change_desktop.innerHTML = defaultData


            features_main_mobile.innerHTML = '';
            features_variant_mobile ? features_variant_mobile.innerHTML = '' : null;
            features_change_mobile.innerHTML = defaultData

            //drawer
            const data = {max_height_adjustment: defaultLength , max_weight: defaultMaxWeight, max_user_height: defaultMaxUserHeight }
            const markup = updateSpecs(data)
            defaultSpecsContainer.innerHTML = "";
            variantSpecsContainer.innerHTML = markup

            drawerVariantBullets.innerHTML = defaultData
            
            // Drawer - notes
            drawerNotesDefault.innerHTML = "";
            drawerNotesVariant.innerHTML = updateNote({'max_weight': notesData.max_weight, 'max_height': notesData.max_height })
            
            return console.log("Show original")
          }
         
         
          
      } else if (mutation.type === "attributes") {
        console.log(`The ${mutation.attributeName} attribute was modified, sku_node features`);
      }
    }
  };
  
  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);
  
  // Start observing the target node for configured mutations
  observer.observe(sku_node, config);

  // First render
  const sku_id = document.querySelector("[data-js-product-sku] span");
  if(!sku_id){
    return console.log("Cant find sku_id element drawer")
  }
  console.log("SKU, drawer", sku_id.innerHTML)

  const variants_metafield = variantsData[sku_id.innerHTML]
  console.log("variants_metafield", variants_metafield)

  if(variants_metafield.max_height_adjustment === 'null' || variants_metafield.max_weight === 'null' || variants_metafield.max_user_height === 'null'){
    return console.log("Null properties for variants_metafield drawer")
  }


  // first render - bullets right column
  const specsContainer = document.querySelector("[data-js-specs-variant]")
  const markup = updateSpecs(variants_metafield, 'first-render')
  specsContainer.innerHTML = markup

  // first render - drawer
  const drawerDefaultBullets = document.querySelector("[data-js-drawer-default-bullets]")
  const drawerVariantBullets = document.querySelector("[data-js-drawer-variant-bullets]")

  if(variants_metafield.bullets !== 'null'){
    drawerVariantBullets.innerHTML = variants_metafield.bullets
    drawerDefaultBullets.innerHTML = "";
  }

  // first render - notes
  const drawerNotesDefault = document.querySelector("[data-js-drawer-notes-default]")
  const drawerNotesVariant = document.querySelector("[data-js-drawer-notes-variant]")
  if(variants_metafield.max_height_adjustment !== 'null' || variants_metafield.max_weight !== 'null' ){
    drawerNotesDefault.innerHTML = "";
    drawerNotesVariant.innerHTML  = updateNote({'max_weight': variants_metafield.max_weight, 'max_height': variants_metafield.max_user_height })
  }

  

  // helper
    function updateSpecs(data, type = null){
     return ` <ul ${type === 'first-render' ? "class='first-render'" : '' }>
        <li> Length: ${data.max_height_adjustment} </li>
        <li> Max User Weight: ${data.max_weight} Pounds</li>
        <li> Max User Height: ${data.max_user_height} Approx.</li>
        <li> Max Size: ${data.max_height_adjustment}</li>
      </ul>
      `
      }

  function updateNote(data){
    return `
        <p class="mb-0 mt-20">
          <strong>Please Note:</strong> This Cane is designed for users that weight up to <strong>${data.max_weight}lbs.</strong>
          and up to <strong>${data.max_height} </strong> in height.
        </p>
        `
  }

  
})
